<script lang="ts" setup>
import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { computed, onMounted, reactive, ref } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import DecisionBtn from '@/components/input/Btn/DecisionBtn.vue';
import CancelBtn from '@/components/input/Btn/CancelBtn.vue';
import { flexRow, padding2em } from '@/appLogic/constants/layoutConst';
import { CustomStyle } from '@/appLogic/interfaces/style';

// interface
type ModalSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'auto';

// props
const props = withDefaults(
  defineProps<{
    modalState: boolean;
    okButtonText?: string;
    cancelButtonText?: string;
    size?: ModalSize | number;
    okValidate?: boolean;
  }>(),
  {
    okButtonText: String(i18n.t('続行')),
    cancelButtonText: String(i18n.t('変更')),
    // eslint-disable-next-line vue/require-valid-default-prop
    size: 'md',
    okValidate: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'validate-ok'): void;
  (e: 'ok'): void;
  (e: 'cancel'): void;
  (e: 'outside-click', outsideClick: boolean): void;
}>();

// style variables
const FlexRow = flexRow;

//変数
const t = i18n.t;
const setState = reactive({ state: props.modalState }) as Record<string, any>;

//computed

// イベント

//関数
const onClickOk = () => {
  if (props.okValidate) {
    emits('validate-ok');
  } else {
    emits('ok');
  }
};
const onClickCancel = () => {
  emits('cancel');
};

// TODO: md-系だとどこかで.preventDefaultされてるか何かでoutside-clickのイベントが上がってこないのでこいつ現状意味ない。。。
// そもそもmd系を使わないようにしたい
const outsideClick = (outsideClick) => {
  emits('outside-click', outsideClick);
};

// customStyle
// decisionBtnのカスタムスタイル
const decisionBtnCustomStyle: CustomStyle = {
  Div: {
    marginRight: '50px',
  },
};
// cancelBtnCustomStyleのカスタムスタイル
const cancelBtnCustomStyle: CustomStyle = {
  Div: {
    marginLeft: '50px',
  },
};
</script>

<template>
  <Modal :modal-state="modalState" :size="size" @outside-click="outsideClick">
    <div class="confirm-context">
      <slot />
    </div>
    <FlexRow>
      <DecisionBtn :label-name="okButtonText" :custom-style="decisionBtnCustomStyle" @click="onClickOk" />
      <CancelBtn :label-name="cancelButtonText" :custom-style="cancelBtnCustomStyle" @click="onClickCancel" />
    </FlexRow>
  </Modal>
</template>

<style lang="scss" scoped />
